import React, { FunctionComponent } from "react";

import {
  SiteConfig_siteConfig_alarmsConf,
} from "graphql/generated";

import AlarmTypes from "./AlarmTypes";


interface IProps {
  siteId: string;
  basePath: string;
  alarmsConf: SiteConfig_siteConfig_alarmsConf;
  timezone: string;
}


const Alarms: FunctionComponent<IProps> = ({
  alarmsConf,
  siteId,
  basePath,
  timezone,
}) => {
  return (
    <>
      <AlarmTypes
        alarmsConf={alarmsConf}
        timezone={timezone}
        siteId={siteId}
        basePath={basePath}
      />
    </>
  );
};

export default Alarms;
